export const environment = {
  production: false,
  baseURL: 'http://localhost:3000/api',

  projectName: 'Passion-Pharma',

  version: '0.0.4',
};
